import React from "react";
import { useReveal } from "../hooks/useReveal";

const AboutSection = () => {
  const [headingRef, headingIn] = useReveal();
  const [pathRef, pathIn] = useReveal();
  const [textRef, textIn] = useReveal();
  const [closingRef, closingIn] = useReveal();

  return (
    <section id="about" className="relative pt-12 pb-28 sm:pt-12 sm:pb-40 bg-ink text-paper overflow-hidden">
      <div
        className="absolute -top-24 -right-24 w-[34rem] h-[34rem] rounded-full blur-3xl opacity-20"
        style={{ background: "radial-gradient(circle,#7E6BCB,transparent 60%)" }}
      />
      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div ref={headingRef} className={`reveal ${headingIn ? "in" : ""}`}>
          <span className="kicker text-violet-c/90">About us</span>
          <h2 className="mt-6 font-display font-normal text-4xl sm:text-5xl leading-[1.12] tracking-tight">
            <span className="block line">We start from inside the problem.</span>
            <span className="block italic text-rose line">Not as a spectator.</span>
          </h2>
        </div>

        {/* hand-drawn method path */}
        <div ref={pathRef} className={`reveal mt-14 ${pathIn ? "in" : ""}`} style={{ transitionDelay: ".1s" }}>
          <svg viewBox="-30 0 980 150" className="w-full max-w-3xl mx-auto">
            <path
              d="M70 60 C 190 92, 250 16, 360 38 S 520 92, 610 64 S 780 18, 858 48"
              fill="none"
              stroke="#D8073C"
              strokeWidth="3"
              strokeLinecap="round"
              className="draw-path"
            />
            <g>
              <circle className="node-pop" style={{ animationDelay: ".5s" }} cx="70" cy="60" r="9" fill="#D8073C" />
              <circle className="node-pop" style={{ animationDelay: ".8s" }} cx="360" cy="38" r="9" fill="#7E6BCB" />
              <circle className="node-pop" style={{ animationDelay: "1.1s" }} cx="610" cy="64" r="9" fill="#E4915A" />
              <circle className="node-pop" style={{ animationDelay: "1.4s" }} cx="858" cy="48" r="9" fill="#D8073C" />
            </g>
            <g fill="#FCFAFF" fontWeight="600" fontSize="15" textAnchor="middle" fontFamily="Inter">
              <text className="node-pop" style={{ animationDelay: ".5s" }} x="70" y="102">Live it firsthand</text>
              <text className="node-pop" style={{ animationDelay: ".8s" }} x="360" y="80">Build the intuition</text>
              <text className="node-pop" style={{ animationDelay: "1.1s" }} x="610" y="106">Think it through</text>
              <text className="node-pop" style={{ animationDelay: "1.4s" }} x="858" y="90">Build and refine</text>
            </g>
          </svg>
        </div>

        <div
          ref={textRef}
          className={`reveal mt-8 space-y-5 text-lg sm:text-xl text-paper/70 leading-relaxed font-normal max-w-3xl mx-auto ${textIn ? "in" : ""}`}
          style={{ transitionDelay: ".15s" }}
        >
          <p>
            We put ourselves inside the problem until{" "}
            <span className="text-paper font-normal">the friction is ours</span>. That's where
            intuition comes from. Then we think it through together, build the fix, and refine it.
            Each pass leaves the work sharper. And us too.
          </p>
        </div>

        <div
          ref={closingRef}
          className={`reveal mt-10 flex flex-col items-center ${closingIn ? "in" : ""}`}
          style={{ transitionDelay: ".2s" }}
        >
          <span className="w-12 h-px bg-rose/60 mb-10" />
          <p className="italic font-normal text-2xl sm:text-3xl leading-snug text-paper max-w-2xl">
            <span className="block">Research and Development isn't a department.</span>
            <span className="block text-rose">It's our whole culture.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;